import { Accents, Absolutes, Statuses, ExternalBrand, Markets, Premium } from '@picsart/ds-foundation';

const ButtonSkinPrimary = generateButtonSkin(Accents.primary);
const ButtonSkinSecondary = generateButtonSkin(Accents.secondary);
const ButtonSkinTertiary = generateButtonSkin(Accents.tertiary);
const ButtonSkinAbsoluteWhite = generateButtonSkin(Absolutes.white);
const ButtonSkinAbsoluteBlack = generateButtonSkin(Absolutes.black);
const ButtonSkinMarket = generateButtonSkin(Markets);
const ButtonSkinPremium = generateButtonSkin(Premium);
const ButtonSkinStatusError = generateButtonSkin(Statuses.error);
const ButtonSkinStatusSuccess = generateButtonSkin(Statuses.success);
const ButtonSkinStatusWarning = generateButtonSkin(Statuses.warning);
const ButtonSkinStatusInformation = generateButtonSkin(Statuses.information);
const ButtonSkinStatusPositive = generateButtonSkin(Statuses.positive);
const ButtonSkinStatusNegative = generateButtonSkin(Statuses.negative);
const ButtonSkinStatusHighLight = generateButtonSkin(Statuses.highLight);
const ButtonSkinExternalBrandGoogle = generateButtonSkin(ExternalBrand.google);
const ButtonSkinExternalBrandFacebook = generateButtonSkin(ExternalBrand.facebook);
const ButtonSkinExternalBrandApple = generateButtonSkin(ExternalBrand.apple);
const ButtonSkinExternalBrandSnapchat = generateButtonSkin(ExternalBrand.snapchat);
const ButtonSkinExternalBrandKakao = generateButtonSkin(ExternalBrand.kakao);
const ButtonSkinExternalBrandLine = generateButtonSkin(ExternalBrand.line);
function generateButtonSkin(colorPackage) {
    return {
        base: colorPackage.base.default,
        baseAction: colorPackage.base.action,
        baseActive: colorPackage.base.active,
        baseActiveAction: colorPackage.base.activeAction,
        text: colorPackage.text.default,
        textAction: colorPackage.text.action,
        textActive: colorPackage.text.active,
        textActiveAction: colorPackage.text.activeAction,
    };
}

export { ButtonSkinAbsoluteBlack, ButtonSkinAbsoluteWhite, ButtonSkinExternalBrandApple, ButtonSkinExternalBrandFacebook, ButtonSkinExternalBrandGoogle, ButtonSkinExternalBrandKakao, ButtonSkinExternalBrandLine, ButtonSkinExternalBrandSnapchat, ButtonSkinMarket, ButtonSkinPremium, ButtonSkinPrimary, ButtonSkinSecondary, ButtonSkinStatusError, ButtonSkinStatusHighLight, ButtonSkinStatusInformation, ButtonSkinStatusNegative, ButtonSkinStatusPositive, ButtonSkinStatusSuccess, ButtonSkinStatusWarning, ButtonSkinTertiary };
